<mat-card appCard style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2)">


        <!-- <app-item [label]="fields.bidNo.label | translate" [value]="projet.planNo"></app-item>
        <app-item [label]="fields.bidNoModif.label | translate" [value]=""></app-item>
        <app-item [label]="fields.publicDt.label | translate" [value]="projet.publicDt"></app-item>
        <app-item *ngIf="getlang()==='fr'" [label]="fields.planNmFr.label | translate" [value]="projet.planNmFr"></app-item>
        <app-item *ngIf="getlang()==='ar'" [label]="fields.planNmFr.label | translate" [value]="projet.planNmAr"></app-item>
        <app-item [label]="fields.dateprev.label | translate" [value]=""></app-item>
        <app-item *ngIf="getlang()==='fr'" [label]="fields.lieuouv.label | translate" [value]="projet.executionPlaceStrFr"></app-item>
        <app-item *ngIf="getlang()==='ar'" [label]="fields.lieuouv.label | translate" [value]="projet.executionPlaceStrAr"></app-item>
        <app-item [label]="fields.acheteur.label | translate" [value]="projet.instNm"></app-item>
        <app-item *ngIf="getlang()==='fr'" [label]="fields.srfinanc.label | translate" [value]="projet.financialMethodStrFr"></app-item>
        <app-item *ngIf="getlang()==='ar'" [label]="fields.srfinanc.label | translate" [value]="projet.financialMethodStrAr"></app-item>
        <app-item *ngIf="getlang()==='fr'" [label]="fields.tcommande.label | translate" [value]="typecommande"></app-item>
        <app-item *ngIf="getlang()==='ar'" [label]="fields.tcommande.label | translate" [value]="typecommandeAr"></app-item>
        <app-item [label]="fields.annee.label | translate" [value]="projet.planYear"></app-item>
        <app-item [label]="fields.dateprevelab.label | translate" [value]="projet.biddingDocExpDt"></app-item>
        <app-item [label]="fields.dateprevpub.label | translate" [value]="projet.bidPublicExpDt"></app-item>
        <app-item [label]="fields.dateprevupres.label | translate" [value]="projet.procCommissionExpDt"></app-item>
        <app-item *ngIf="getlang()==='fr'"  [label]="fields.encouragement.label | translate" [value]="valmarchcadre"></app-item>
        <app-item *ngIf="getlang()==='ar'" [label]="fields.encouragement.label | translate" [value]="valmarchcadreAr"></app-item> -->
        <mat-card-header class="titree">
            {{ "Plan prévisionnel annuel détaillé" | translate }}
        </mat-card-header>
        <mat-card-content class="card-content">
            <table mat-table [dataSource]="dataSource" style="width: 100%;">
    
                <ng-container matColumnDef="label" sticky="true">
                  <td mat-cell *matCellDef="let row">{{ row.label  | translate }}</td>
                </ng-container>
          
          
                <ng-container [matColumnDef]="'column' + i" *ngFor="let column of data; let i = index">
             
                  <td mat-cell *matCellDef="let row"> {{ row['column' + i]  | translate | customDate }} </td>
                </ng-container>
  
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
            <app-empty-list-container [list]="dataSource.data" [withoutBorder]="true"></app-empty-list-container>
        </mat-card-content>
        
</mat-card>
<br>
<div align="right" *ngIf="current_lang=='fr'|| current_lang=='en'">
  <button [routerLink]="['/portail/projets']"  mat-raised-button style="background-color:#3E90D0; color: white;">{{"Liste"|translate}}</button>
</div>

<div style="float: left;" *ngIf="current_lang=='ar'">
  <button [routerLink]="['/portail/projets']"  mat-raised-button style="background-color:#3E90D0; color: white;">{{"Liste"|translate}}</button>
</div>
